import { Grid } from '@mui/material'
import { ItemOption } from 'components/FormInputSelect'
import { StatusMeasureItem } from './components/StatusMeasureItem'

type DocumentListProps = {
  typeOptions: ItemOption[]
  typeOptionsLaPsc: ItemOption[]
  disabled?: boolean
}
export const StatusMeasureList: React.FC<DocumentListProps> = ({
  typeOptions,
  typeOptionsLaPsc,
  disabled,
}) => {
  return (
    <Grid container item xs={12} spacing={2}>
      {/* {documentsFields.map((_, i) => ( */}
      <Grid item xs={12}>
        <StatusMeasureItem
          //index={i}
          typeOptions={typeOptions}
          typeOptionsLaPsc={typeOptionsLaPsc}
          // isRemovable={documentsFields.length > 1}
          disabled={disabled}
        />
      </Grid>
      {/* ))} */}
    </Grid>
  )
}
